import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DateValidators {
  
  /**
   * Validator that ensures a valid date that is in the past
   * Perfect for Date of Birth fields
   */
  static pastDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      
      const date = new Date(value);
      const today = new Date();
      today.setHours(23, 59, 59, 999); // Set to end of day for comparison
      
      if (isNaN(date.getTime())) {
        return { invalidDate: true };
      }
      
      if (date > today) {
        return { futureDate: true };
      }
      
      return null;
    };
  }

  /**
   * Validator that just ensures it's a valid date
   * Can be past, present, or future
   */
  static validDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      
      const date = new Date(value);
      
      if (isNaN(date.getTime())) {
        return { invalidDate: true };
      }
      
      return null;
    };
  }

  /**
   * Validator for future dates only
   * Useful for visa expiry, appointment dates, etc.
   */
  static futureDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      
      const date = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Set to start of day for comparison
      
      if (isNaN(date.getTime())) {
        return { invalidDate: true };
      }
      
      if (date <= today) {
        return { pastDate: true };
      }
      
      return null;
    };
  }

  
}